import React from "react";
import { ElementsConsumer } from "@stripe/react-stripe-js";

/**
 * Replacement for react-stripe-elements' `injectStripe` HOC.
 *
 * Injects `stripe` and `elements` props into the wrapped component, sourced from
 * the surrounding `<Elements>` provider. Unlike the old `injectStripe`, payment
 * methods no longer auto-locate the mounted Element, so callers retrieve it with
 * `elements.getElement(CardElement)` / `elements.getElement(AuBankAccountElement)`.
 */
export const withStripe = (WrappedComponent) => {
  const WithStripe = (props) => (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <WrappedComponent {...props} stripe={stripe} elements={elements} />
      )}
    </ElementsConsumer>
  );
  return WithStripe;
};

export default withStripe;
